import { lazy } from 'react';
import MainLayout from '@/layout/MainLayout';
import Loadable from '@/ui-component/Loadable';
import ProtectedRoute from '../component/function/ProtectedRoute';
import { element } from 'prop-types';

// dashboard routing
// const Notification = Loadable(lazy(() => import('@/views/notification/index')));
const Profile = Loadable(lazy(() => import('../views/profile/index_off')));

//!ADMIN
//* register
const RegisterStudent = Loadable(lazy(() => import('../views/pages/admin/register/RegisterStudent')));
const ClassManagement = Loadable(lazy(() => import('../views/pages/admin/register/ClassManagement')));
const ViewStudentInRoom = Loadable(lazy(() => import('../views/pages/admin/register/ViewStudentInRoom')));
const AddStudentPage = Loadable(lazy(() => import('../views/pages/admin/register/AddStudentPage')));
const ViewStudentPage = Loadable(lazy(() => import('../views/pages/admin/register/ViewStudentPage')));
const EditStudentPage = Loadable(lazy(() => import('../views/pages/admin/register/EditStudentPage')));
const ClassManagementStudent = Loadable(lazy(() => import('../views/pages/admin/register/ClassManagementStudent')));
//*leav
const Leav = Loadable(lazy(() => import('../views/pages/admin/Leav/Leav')));
const LeavClass = Loadable(lazy(() => import('../views/pages/admin/Leav/LeavClass')));
const LeavView = Loadable(lazy(() => import('../views/pages/admin/Leav/LeavView')));
//*attendance
const Attendance = Loadable(lazy(() => import('../views/pages/admin/Attendance/Attendance')));
const AttendanceClass = Loadable(lazy(() => import('../views/pages/admin/Attendance/AttendanceClass')));
const AttendanceView = Loadable(lazy(() => import('../views/pages/admin/Attendance/AttendanceView')));

//* notification page
const NotificationPage = Loadable(lazy(() => import('../views/pages/admin/notification_menu/NotificationPage')));

//main-menu
const Main = Loadable(lazy(() => import('../views/pages/admin/main_menus/main')));
// เพิ่มการ import คอมโพเนนต์ MainTabs
const MainTabs = Loadable(lazy(() => import('../views/pages/admin/main_menus/main_tabs')));
const MainTabs_student = Loadable(lazy(() => import('../views/pages/student/main_menus/main_tabs')));

const Release = Loadable(lazy(() => import('../views/press_release/Release')));
const Addinformation = Loadable(lazy(() => import('../views/press_release/addinfomation/addinformation')));
const Viewinfomation = Loadable(lazy(() => import('../views/press_release/viewinformation/viewinformation')));
const Editinfomation = Loadable(lazy(() => import('../views/press_release/editinformation/editinformation')));

//* agenda
const Agenda = Loadable(lazy(() => import('../views/pages/admin/agenda/Agenda')));
const EditAgenda = Loadable(lazy(() => import('../views/pages/admin/agenda/EditAgenda')));
const ViewAgenda = Loadable(lazy(() => import('../views/pages/admin/agenda/ViewAgenda')));
//!STUDENT
const LeavStudent = Loadable(lazy(() => import('../views/pages/student/Leav')));
const AttendanceStudent = Loadable(lazy(() => import('../views/pages/student/Ateendance')));
const Profile_S = Loadable(lazy(() => import('../views/profile/index_student')));
const Home_student = Loadable(lazy(() => import('../views/pages/student/main_menus/main')));
const NotificationStudentPage = Loadable(lazy(() => import('../views/pages/student/student_notification/NotificationStudentPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <ProtectedRoute element={MainLayout} />,
  children: [
    {
      path: 'admin',
      children: [
        {
          path: 'main-menu',
          children: [
            {
              path: '',
              element: <Main />
            },
            {
              path: 'view',
              element: <MainTabs />
            }
          ]
        },
        {
          path: 'agenda',
          children: [
            {
              path: '',
              element: <Agenda />
            },
            {
              path: 'add',
              element: <EditAgenda />
            },
            {
              path: 'view',
              element: <ViewAgenda />
            }
          ]
        },
        {
          path: 'register',
          children: [
            {
              path: 'student',
              // element: <RegisterStudent />
              children: [
                {
                  path: '',
                  element: <RegisterStudent />
                },
                {
                  path: 'view',
                  element: <ViewStudentInRoom />
                },
                {
                  path: 'add',
                  element: <AddStudentPage />
                },
                {
                  path: 'view_student/:student_id',
                  element: <ViewStudentPage />
                },
                {
                  path: 'edit_student/:id',
                  element: <EditStudentPage />
                }
              ]
            },
            {
              path: 'class-management',
              element: <ClassManagement />
            },
            {
              path: 'class-management-student',
              element: <ClassManagementStudent />
            }
          ]
        },
        {
          path: 'leave',
          // element: <Leav />
          children: [
            {
              path: '',
              element: <Leav />
            },
            {
              path: 'class',
              children: [
                {
                  path: '',
                  element: <LeavClass />
                },
                {
                  path: 'view',
                  element: <LeavView />
                }
              ]
            }
          ]
        },
        {
          path: 'attendance',
          children: [
            {
              path: '',
              element: <Attendance />
            },
            {
              path: 'class',
              children: [
                {
                  path: '',
                  element: <AttendanceClass />
                },
                {
                  path: 'view',
                  element: <AttendanceView />
                }
              ]
            }
          ]
        },
        {
          path: 'notification',
          children: [
            {
              path: 'index',
              element: <NotificationPage />
            }
          ]
        },
        {
          path: 'account',
          children: [
            {
              path: '',
              element: <Profile />
            },
            {
              path: 'index',
              element: <Profile />
            }
          ]
        },
        {
          path: 'press_release',
          element: <Release />
        },
        {
          ///admin/addinformation
          path: 'addinformation',
          element: <Addinformation />
        },

        {
          path: 'viewinformation',
          element: <Viewinfomation />
        },
        {
          path: 'editinformation',
          element: <Editinfomation />
        }
      ]
    },
    {
      path: 'student',
      children: [
        {
          path: 'main-menu',
          children: [
            {
              path: '',
              element: <Home_student />
            },
            {
              path: 'view',
              element: <MainTabs_student />
            }
          ]
        },
        {
          path: 'leav',
          element: <LeavStudent />
        },
        {
          path: 'atten',
          element: <AttendanceStudent />
        },
        {
          path: 'student_notification',
          element: <NotificationStudentPage />
        },
        {
          path: 'account',
          children: [
            {
              path: '',
              element: <Profile_S />
            },
            {
              path: 'index',
              element: <Profile_S />
            }
          ]
        }
        // {
        //   path: 'attendance',
        //   children: [
        //     {
        //       path: '',
        //       element: <Attendance_std />
        //     },
        //     {
        //       path: 'class',
        //       children: [
        //         {
        //           path: '',
        //           element: <AttendanceClass_std />
        //         },
        //         {
        //           path: 'view',
        //           element: <AttendanceView_std />
        //         }
        //       ]
        //     }
        //   ]
        // }
      ]
    }
  ]
};

export default MainRoutes;
